import * as pbi from '../../public/index.component'
import { AdminService } from '../admin.service';
declare var jquery: any;
declare var $: any;
declare var ace: any;
@pbi.Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css']
})

export class FooterComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    items: Object[];
    PageTitle: string = "Quản lý Footer";
    //#region Footer
    Title: string = "";
    ID: string = "-1";
    Name: string = "";
    Iframe: string = "";
    ColumnArr: string = "";
    Active: boolean = false;
    Action: string = "";
    HinhAnh: string = this.pb_func.NotImage;
    DelHinhAnh: string = "";
    FileHinhAnh: any = null;
    LinkOrg: string = "";
    //#endregion Footer
    constructor(private adminService: AdminService, private router: pbi.Router) {
        adminService.openLoading0();
    }
    ngOnInit() {
        var this_sav = this;
        this_sav.pb_func.loadScript([
            'assets/global/scripts/datatable.js',
            'assets/global/plugins/datatables/datatables.min.js',
            'assets/global/plugins/datatables/plugins/bootstrap/datatables.bootstrap.js',
            'assets/global/plugins/jstree/dist/jstree.min.js',
            'assets/pages/scripts/ui-tree.min.js',
            'assets/global/plugins/jquery-inputmask/jquery.inputmask.bundle.min.js',
            'assets/global/plugins/bootstrap-tagsinput/bootstrap-tagsinput.js',
            'assets/src-noconflict/ace.js',
            'assets/more/script/fixHeightContent.js'
        ], 'footer', function () {
            this_sav.tableFooter();
            this_sav.TreeViewHinhAnh();
        });
    };

    //#region Load Table Select
    tableFooter() {
        var this_sav = this;
        var url = this_sav.pb_func.getBaseUrl() + "api/Footer/load";
        var table = $('#datatable_ajax');
        var tbl = table.DataTable({
            "bProcessing": true,
            "bServerSide": true,
            "sAjaxSource": url,
            "bSort" : false,
            "fnServerData": function (sSource, aoData, fnCallback, oSettings) {
                oSettings.jqXHR = $.ajax({
                    "dataType": 'json',
                    "type": "POST",
                    "url": sSource,
                    "data": aoData,
                    "headers": { 'Authorization': this_sav.pb_func.getToken() },
                    "success": function(json) {
                        this_sav.items = json.aaData;
                        if (this_sav.items.length > 0) {
                            this_sav.LinkOrg = this_sav.items[0]["LinkOrg"];
                        }
                        fnCallback(json);
                    },
                });
            },
            "columns": [
                { "data": null },
                { "data": "Name" },
                { "data": "HinhAnh" },
                { "data": "ColumnArr" },
                { "data": "Active" },
                { "data": "Action" }
            ],
            "lengthMenu": [
                [5],
                [5]
            ],
            "pageLength": 5,
            "drawCallback": function (settings) {
                $('.EditFooterModal').off('click');
                $('.EditFooterModal').click(function () {
                    this_sav.EditFooterModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });

                $('.EditHinhAnhModal').off('click');
                $('.EditHinhAnhModal').click(function () {
                    this_sav.EditHinhAnhModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });
                
                $('.ActiveFooterModal').off('click');
                $('.ActiveFooterModal').click(function () {
                    this_sav.Active = $(this).prop('checked');
                    this_sav.ID = $(this).attr('idsp');
                    this_sav.UpdateFooter(this, $(this).attr('typesp'));
                });
                
                $('.EditColumnArrModal').off('click');
                $('.EditColumnArrModal').click(function () {
                    this_sav.EditColumnArrModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });
            },
            "rowCallback": function (row, data, displayNum, displayIndex, dataIndex) {
                var page = this.fnPagingInfo().iPage;
                var length = this.fnPagingInfo().iLength;
                var index = (page * length + (displayIndex + 1));
                $('td:eq(0)', row).html(index);
            },
            "initComplete": function (settings, json) {
                this_sav.adminService.closeLoading(() => {

                });
            }
        });
    }
    //#endregion Load Table Select

    //#region Modal
    EditFooterModal($event, ID: string, type: string) {
        var this_sav = this;
        var a = $event.currentTarget;
        if (type != 'add') {
            a = $event;
        }
        var tr = $(a).parent().parent().parent();
        this_sav.ID = ID;
        
        var editModal = $('#EditFooterModal');
        if (type == "add") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            this_sav.Name = "";
            this_sav.Iframe = "";
            this_sav.Title = "Thêm mới Footer";
        }
        else if (type == "edit") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            var row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];
            this_sav.Name = row["Name"];
            this_sav.Iframe = row["Iframe"];
            this_sav.Title = `Sửa Footer "${this_sav.Name}"`;
        }
        else if (type == "del") {
            var row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];
            this_sav.Name = row["Name"];
            this_sav.Title = `Xóa Footer "${this_sav.Name}"`;
        }
        this_sav.Action = type;
        this_sav.Active = false;
        $(a).next().click();
    }
    //#endregion Modal

    //#region Add, Edit, Del
    UpdateFooter($event, type: string) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        var editModal = $('#EditFooterModal');
        var a = $event.currentTarget;
        if(a == null)
            a = $event;

        if(type == "updateColumnArr") {
            this_sav.ColumnArr = ace.edit("ColumnArr").getValue();
        }
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/Footer/Update', 'POST',
            {
                ID: this_sav.ID, Name: this_sav.Name, ColumnArr: this_sav.ColumnArr,
                Iframe: this_sav.Iframe, Active: this_sav.Active, Type: type
            },
            null, function (status, mess) {
                this_sav.adminService.closeLoading(function () { });
                var elemNotify = editModal.find('.notifyModal');
                if(type == "updateActive") {
                    elemNotify = $;
                    if (status == 0) {
                        var checked = $(a).prop('checked');
                        $(a).prop('checked', checked !== true);
                    }
                }
                else if(type == "updateColumnArr") {
                    elemNotify = $('#EditColumnArrModal').find('.notifyModal');
                }

                if (status == 0) {
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'success' });
                }
            });
    }

    DeleteFooter($event, type: string) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/Footer/Delete', 'POST', { ID: this_sav.ID }, null, function (status, mess) {
            this_sav.adminService.closeLoading(function () {
                if (status == 0) {
                    $.notify(mess, { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    $.notify(mess, { globalPosition: 'bottom right', className: 'success' });
                }
                $('#DelFooterModal .close').click();
            });
        });
    }
    //#endregion Add, Edit, Del

    //#region HinhAnh
    EditHinhAnhModal($event, ID: string, type: string) {
        var this_sav = this;
        var treeView = $('#treeViewHinhAnh');
        $('#LinktreeViewHinhAnh').prop('disabled', true);
        var a = $event;
        this_sav.adminService.openLoading1();
        this_sav.ID = ID;
        var row = this_sav.items.filter(function (item) {
            return item["ID"] == ID;
        })[0];
        this_sav.Name = row["Name"];
        this_sav.HinhAnh = this_sav.pb_func.NotImage;
        $(a).next().click();
        treeView.jstree(true).refresh();
    }

    TreeViewHinhAnh() {
        var this_sav = this;
        var treeView = $('#treeViewHinhAnh');
        var inputTreeView = $('#LinktreeViewHinhAnh');
        var fileTreeView = $('#FiletreeViewHinhAnh');
        var url = this_sav.pb_func.getBaseUrl() + "api/Footer/HinhAnh";
        treeView.jstree({
            "core": {
                "themes": {
                    "responsive": false
                },
                // so that create works
                "check_callback": true,
                'data': {
                    'url': function (node) {
                        return url;
                    },
                    'data': function (node) {
                        return { 'ID': this_sav.ID };
                    },
                    'type': 'POST',
                    'headers': { 'Authorization': this_sav.pb_func.getToken() },
                    'success': function () {
                        this_sav.adminService.closeLoading(function () { });
                    }
                }
            },
            "types": {
                "default": {
                    "icon": "fa fa-folder icon-state-warning icon-lg",
                    "max_depth": 1,
                },
                "file": {
                    "icon": "fa fa-file icon-state-warning icon-lg"
                }
            },
            "state": { "key": "demo3" },
            "plugins": ["contextmenu", "dnd", "state", "types"]
        });

        treeView.on('changed.jstree', function (e, data) {
            if (this_sav.HinhAnh !== "delete") {
                if (data.node != null) {
                    var id = data.node.id;
                    fileTreeView.val('');
                    this_sav.FileHinhAnh = null;

                    if (id != 'notSelectNode') {
                        inputTreeView.prop('disabled', false);
                        var href = data.node.a_attr.href;
                        var image = data.node.a_attr.image;
                        inputTreeView.val(href);
                        if (image != null && image != '') {
                            this_sav.HinhAnh = this_sav.LinkOrg + image;
                        }
                        else {
                            this_sav.HinhAnh = this_sav.pb_func.NotImage;
                        }
                    }
                    else {
                        this_sav.HinhAnh = this_sav.pb_func.NotImage;
                        inputTreeView.val('');
                        inputTreeView.prop('disabled', true);
                    }
                }
            }
            else {
                this_sav.HinhAnh = this_sav.pb_func.NotImage;
                inputTreeView.click();
            }
        });

        treeView.on("delete_node.jstree", function (e, data) {
            this_sav.HinhAnh = "delete";
        });

        inputTreeView.focusout(function () {
            var nodes = treeView.jstree('get_selected', true);
            nodes[0].a_attr.href = $(this).val();
        });

        inputTreeView.keypress(function (e) {
            if (e.which == 13) {
                treeView.focus();
            }
        });
    }

    ChangeHinhAnh($event) {
        if ($('#LinktreeViewHinhAnh').prop('disabled') !== true) {
            var a = $event.currentTarget;
            $(a).find('input[type="file"]').click();
        }
        else {
            alert('Error');
        }
    }

    readHinhAnh($event) {
        var this_sav = this;
        var reader = new FileReader();
        reader.onload = function (ee) {
            this_sav.HinhAnh = reader.result;
        };

        try {
            this_sav.FileHinhAnh = $event.currentTarget.files[0];
            reader.readAsDataURL(this_sav.FileHinhAnh);
        }
        catch (r) {
            this_sav.HinhAnh = this_sav.pb_func.NotImage;
        }
    }

    SaveHinhAnh($event) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        var treeView = $('#treeViewHinhAnh');
        var editModal = $('#EditHinhAnhModal');
        var nodes = treeView.jstree('get_selected', true);
        if (nodes.length > 0)
            this_sav.DelHinhAnh = nodes[0].a_attr.image;
        else
            this_sav.DelHinhAnh = "";

        if (this_sav.FileHinhAnh != null) {
            nodes[0].a_attr.image = 'NewImageLinkFor';
        }
        var v = treeView.jstree(true).get_json('#', { flat: true })
        v.splice(0, 1);

        let formData: FormData = new FormData();
        formData.append("ID", this_sav.ID);
        formData.append("HinhAnh", JSON.stringify(v));
        formData.append("DelHinhAnh", this_sav.DelHinhAnh);
        formData.append("FileHinhAnh", this_sav.FileHinhAnh);

        this_sav.pb_func.callAPI('api/Footer/UpdateHinhAnh', 'POST', formData, null,
            function (status, mess) {
                this_sav.adminService.closeLoading(function () { });
                if (status == 0) {
                    editModal.find('.notifyModal').notify(mess.toString(), { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    treeView.jstree(true).refresh();
                    editModal.find('.notifyModal').notify(mess.toString(), { globalPosition: 'bottom right', className: 'success' });
                }
            });
    }
    //#endregion HinhAnh

    //#region ColumnArr
    EditColumnArrModal($event, ID: string, type: string) {
        var this_sav = this;
        var editor = ace.edit("ColumnArr");
        editor.session.setMode("ace/mode/html");
        editor.setTheme("ace/theme/crimson_editor");
        this_sav.Title = "Cập nhật thông tin Footer";
        this_sav.ID = ID;
        this_sav.ColumnArr = "";
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/Footer/ColumnArr', 'POST', { ID: this_sav.ID }, null, function (status, mess) {
            this_sav.adminService.closeLoading(function () {
                this_sav.ColumnArr = mess;
                editor.setValue(this_sav.ColumnArr);
            });
        });
        $($event).next().click();
    }
    //endregion ColumnArr
}


// WEBPACK FOOTER //
// ./src/app/admin/footer/footer.component.ts